<script lang="ts">
  // UI components
  import { Label } from '$lib/components/ui/label/index.js';
  import * as Select from '$lib/components/ui/select/index.js';

  // RoastLog
  import { phidgetsRTDSettings } from '$lib/PersistedState.svelte';
  import {
    RTD_TYPE_OPTIONS,
    RTD_WIRE_SETUP_OPTIONS,
    getRTDTypeLabel,
    getRTDWireSetupLabel
  } from '$lib/devices/phidgets/rtdConfig';

  const rtdTypeLabel = $derived(getRTDTypeLabel(phidgetsRTDSettings.current.rtdType));
  const wireSetupLabel = $derived(getRTDWireSetupLabel(phidgetsRTDSettings.current.rtdWireSetup));
</script>

<div class="mt-5 grid max-w-md grid-cols-1 gap-4">
  <p class="text-muted-foreground text-sm">These settings apply to all connected RTD probes.</p>

  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col gap-2">
      <Label for="rtd-type">RTD type</Label>
      <Select.Root type="single" name="rtd-type" bind:value={phidgetsRTDSettings.current.rtdType}>
        <Select.Trigger class="w-full">{rtdTypeLabel}</Select.Trigger>
        <Select.Content>
          {#each RTD_TYPE_OPTIONS as option (option.value)}
            <Select.Item value={option.value} label={option.label}>{option.label}</Select.Item>
          {/each}
        </Select.Content>
      </Select.Root>
    </div>

    <div class="flex flex-col gap-2">
      <Label for="rtd-wire-setup">Wire setup</Label>
      <Select.Root
        type="single"
        name="rtd-wire-setup"
        bind:value={phidgetsRTDSettings.current.rtdWireSetup}
      >
        <Select.Trigger class="w-full">{wireSetupLabel}</Select.Trigger>
        <Select.Content>
          {#each RTD_WIRE_SETUP_OPTIONS as option (option.value)}
            <Select.Item value={option.value} label={option.label}>{option.label}</Select.Item>
          {/each}
        </Select.Content>
      </Select.Root>
    </div>
  </div>
</div>
